import { InstalledBaseEventAttributeInput, TypeDefinitionAttribute } from "../codegen/graphql";

export interface SeparatedInstalledBaseEventAttributes {
    attributes: InstalledBaseEventAttributeInput[];
    /** First node-picker value in attribute order — used as relocation target by default,
     *  or as the primary targeted node when the caller didn't supply one. */
    pickerNode?: string;
    /** Legacy alias preserved for callers that already treat the picker as a relocation. */
    relocationNode?: string;
}

const PICKER_INPUT_TYPES = new Set(["installedBaseNodePicker", "installedBaseNodeBrowser"]);

export const separateInstalledBaseEventAttributes = (
    formValues: { [key: string]: any },
    attributes: TypeDefinitionAttribute[],
): SeparatedInstalledBaseEventAttributes => {
    const pickerIndexes = new Set<string>();
    for (const attr of attributes) {
        const inputType = (attr as { inputType?: string | null }).inputType;
        const index = (attr as { index?: string | null }).index;
        if (index && inputType && PICKER_INPUT_TYPES.has(inputType)) {
            pickerIndexes.add(index);
        }
    }

    const result: InstalledBaseEventAttributeInput[] = [];
    let pickerNode: string | undefined;

    for (const [key, value] of Object.entries(formValues)) {
        if (value === undefined) continue;
        if (key.startsWith("_")) continue;
        if (pickerIndexes.has(key)) {
            if (pickerNode === undefined && value !== null && value !== "") {
                pickerNode = String(value);
            }
            continue;
        }
        result.push({
            attributeIndex: key,
            value: value === "" ? null : value,
        });
    }

    return { attributes: result, pickerNode, relocationNode: pickerNode };
};
